module.exports = __webpack_public_path__ + "static/media/grafico-a.567a4225.png";